import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'bebidas.theme';

/** Tema claro/oscuro vía body.ion-palette-dark (patrón Silvanus). */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly oscuro = signal(this.inicial());

  constructor() {
    this.aplicar(this.oscuro());
  }

  alternar(): void {
    const nuevo = !this.oscuro();
    this.oscuro.set(nuevo);
    localStorage.setItem(STORAGE_KEY, nuevo ? 'dark' : 'light');
    this.aplicar(nuevo);
  }

  private inicial(): boolean {
    const guardado = localStorage.getItem(STORAGE_KEY);
    if (guardado) return guardado === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private aplicar(oscuro: boolean): void {
    document.body.classList.toggle('ion-palette-dark', oscuro);
  }
}
